import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'Orders',
		icon: 'acies_order',
		path: 'sales/orders',
		overlay: false,
		children: [],
		parents: ['Sales'],
		permission: '',
		forceTranslateKey: 'sales.sidebar.orders',
	},
	{
		label: 'Orders List',
		icon: 'acies_list',
		path: 'sales/orderslist',
		overlay: false,
		children: [],
		parents: ['Sales'],
		permission: 'configurator:ConfigurationPost',
		forceTranslateKey: 'sales.sidebar.orderslist',
	},
	{
		label: 'Configuration',
		icon: 'acies_configs',
		path: 'sales/configuration',
		overlay: false,
		children: [],
		parents: ['Sales'],
		permission: 'configurator:ConfigurationPost',
		forceTranslateKey: 'sales.sidebar.configuration',
	},
];
